import AttachmentOperationType from 'owa-service/lib/contract/AttachmentOperationType';
import CheckPendingAttachmentOperationResponse from 'owa-service/lib/contract/CheckPendingAttachmentOperationResponse';
import checkPendingAttachmentOperationRequest from 'owa-service/lib/factory/checkPendingAttachmentOperationRequest';
import checkPendingAttachmentOperationOperation from 'owa-service/lib/operation/checkPendingAttachmentOperationOperation';
import RequestOptions from 'owa-service/lib/RequestOptions';

function createRequestBody(
    attachmentId: string,
    itemId: string,
    operationId: string,
    operationType: AttachmentOperationType
) {
    return checkPendingAttachmentOperationRequest({
        ewsAttachmentId: attachmentId,
        itemId: itemId,
        operationId: operationId,
        operationType: operationType,
    });
}

export default function checkPendingAttachmentOperation(
    attachmentId: string,
    itemId: string,
    operationId: string,
    operationType: AttachmentOperationType,
    requestOptions: RequestOptions
): Promise<CheckPendingAttachmentOperationResponse> {
    const requestBody = createRequestBody(attachmentId, itemId, operationId, operationType);
    return checkPendingAttachmentOperationOperation(requestBody, requestOptions);
}
